import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  Container,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'

import { providerEditRequest, provincesGetRequest } from 'common/actions'
import { getLoading, getSuccess } from 'common/reducers/providers'
import { getProvinces } from 'common/reducers/locations'
import { ProfessionalData, Specialties } from 'common/components/partials'

import { Header } from '../layout'

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  card: {
    padding: theme.spacing(3),
    minHeight: '50vh',
  },
  logo: {
    backgroundSize: 'contain',
    height: '10vh',
    [theme.breakpoints.up('md')]: {
      height: '20vh',
    },
  },
  cardContent: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),

    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(6),
    },
  },
  inputBox: {
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  selectBox: {
    width: '100%',
  },
  stepContent: {
    backgroundColor: 'white',
    padding: theme.spacing(2),
  },
}))

function getSteps() {
  return ['Datos Profesionales', 'Especialidades']
}

const Wizard = ({
  provider,
  updateProvider,
  createMultipleSchedule,
  loading,
  success,
  provinces,
  requestProvinces,
  company,
}) => {
  const classes = useStyles()
  const [activeStep, setActiveStep] = useState(0)
  const [wizardData, setWizardData] = useState({})
  const steps = getSteps()
  const history = useHistory()

  useEffect(() => {
    if (!provider) return
    requestProvinces(provider.country.id || provider.country)
    // history.replace('/logout')
  }, [provider])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  useEffect(() => {
    if (activeStep < steps.length) return
    updateProvider({
      ...provider,
      ...wizardData,
      country: provider.country.id,
      province: provider.province.id,
      district: provider.district.id,
      specialties: wizardData.selectedSpecialties.map((s) => s.id),
      wizardComplete: true,
    })
  }, [wizardData])

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <ProfessionalData
            provider={provider}
            changeImage
            company={company}
            onSubmit={(data) => {
              setWizardData({ ...wizardData, ...data })
              setActiveStep(1)
            }}
          />
        )
      case 1:
        return (
          <Specialties
            provider={provider}
            preloadedLicenses={R.reduce(
              (acc, val) => ({
                ...acc,
                [val.specialty]: [
                  {
                    ...val,
                    province: R.find(R.propEq('id', val.province), provinces),
                  },
                ],
              }),
              {},
              provider.validationInformation?.licenseInformation || []
            )}
            selectedSpecialties={wizardData.selectedSpecialties}
            onSubmit={(data) => {
              setWizardData({
                ...wizardData,
                validationInformation: {
                  licenseInformation: R.flatten(
                    R.keysIn(data).map((k) =>
                      data[k].map((l) => ({
                        specialty: k,
                        license: l.license,
                        province: l.province.id,
                        entity: l.entity,
                        date: l.date,
                      }))
                    )
                  ),
                },
              })
              setActiveStep(2)
            }}
            onGoBack={() => setActiveStep(0)}
          />
        )
      default:
        return (
          <Typography className={classes.instructions}>
            Ha finalizado con éxito la registración. Por favor aguarde a que un
            administrador apruebe su solicitud, en las próximas horas le llegará
            un mail con la confirmación
          </Typography>
        )
    }
  }

  return (
    <>
      <Header />
      <Container className={classes.container}>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Box>
              <Box className={classes.stepContent}>
                {getStepContent(activeStep)}
              </Box>
            </Box>
          </>
        )}
      </Container>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    loading: getLoading(state),
    success: getSuccess(state),
    provinces: getProvinces(state),
  }
}

export default connect(mapStateToProps, {
  updateProvider: providerEditRequest,
  requestProvinces: provincesGetRequest,
})(Wizard)
